import React from 'react';
import { Pencil } from 'lucide-react';
export function Footer() {
  return <footer className="bg-white py-12 border-t border-slate-100" data-id="element-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-33">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-34">
          <div className="flex items-center gap-2" data-id="element-35">
            <div className="bg-brand-mint p-2 rounded-lg" data-id="element-36">
              <Pencil size={20} className="text-emerald-700" data-id="element-37" />
            </div>
            <span className="font-display font-bold text-xl text-brand-dark" data-id="element-38">
              Método Escribo Jugando
            </span>
          </div>

          <div className="flex gap-6 text-sm font-medium text-slate-500" data-id="element-39">
            <a href="#" className="hover:text-brand-primary transition-colors" data-id="element-40">
              Términos y Condiciones
            </a>
            <a href="#" className="hover:text-brand-primary transition-colors" data-id="element-41">
              Políticas de Privacidad
            </a>
            <a href="#" className="hover:text-brand-primary transition-colors" data-id="element-42">
              Contacto
            </a>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-slate-100 text-center text-sm text-slate-400" data-id="element-43">
          <p data-id="element-44">
            © {new Date().getFullYear()} Método Escribo Jugando. Todos los
            derechos reservados.
          </p>
          <p className="mt-2 text-xs" data-id="element-45">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
          </p>
        </div>
      </div>
    </footer>;
}